export default __webpack_public_path__ + "static/media/onboarding_imgs_04.ff9ab667.png";